import { Link } from "react-router-dom";
import { useWishlist } from "@/context/WishlistContext";
import ProductCard from "@/components/ProductCard";
import { Heart } from "lucide-react";

export default function Wishlist() {
  const { products, count } = useWishlist();

  return (
    <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 py-12" data-testid="wishlist-page">
      <p className="text-xs uppercase tracking-[0.3em] text-rani font-bold">My favorites</p>
      <h1 className="font-display text-4xl sm:text-5xl text-deepbrown font-bold mt-2">
        Wishlist {count > 0 && <span className="text-rani">({count})</span>}
      </h1>

      {count === 0 ? (
        <div className="bg-white rounded-2xl p-16 mt-8 text-center border border-deepbrown/10">
          <Heart className="h-12 w-12 text-rani mx-auto mb-3" />
          <p className="font-display text-xl text-deepbrown">No favorites yet</p>
          <p className="text-deepbrown/60 mt-1">Tap the heart on any product to save it here.</p>
          <Link to="/shop" className="inline-block mt-5 px-7 py-3 rounded-full bg-rani text-white font-bold">Browse the Shop</Link>
        </div>
      ) : (
        <div className="mt-8 grid grid-cols-2 lg:grid-cols-4 gap-6">
          {products.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
      )}
    </div>
  );
}
